export const checkPoints = [
  {
    tooltipContent: 's5Col1', // Tooltip content for this row
    packages: ['basis', 'basis_plus', 'komfort', 'premium'], // For which packages is this row enabled
    title: '<span>Basisleistungen</span><ul class="inner-row-ul"><li>Installation und ausführliche Einweisung</li><li>24-Stunden-Notrufzentrale</li></ul>' // Content for the row
  },
  {
    tooltipContent: 's5Col2',
    packages: ['basis_plus', 'komfort', 'premium'],
    title: 'Sichere Schlüsselhinterlegung'
  },
  {
    tooltipContent: 's5Col3',
    packages: ['komfort', 'premium'],
    title: 'Einsatzdienst vor Ort - rund um die Uhr'
  },
  {
    tooltipContent: 's5Col4',
    packages: ['komfort', 'premium'],
    title: 'Tagestaste'
  },
  {
    tooltipContent: 's5Col5',
    packages: ['komfort', 'premium'],
    title: 'SOS-Notfall-Dose'
  },
  {
    tooltipContent: 's5Col6',
    packages: ['komfort', 'premium'],
    title: 'Broschüre Wohnraum verbessernde Maßnahmen'
  },
  {
    tooltipContent: 's5Col7',
    packages: ['premium'],
    title: 'Wöchentlicher persönlicher Anruf'
  },
  {
    tooltipContent: 's5Col8',
    packages: ['premium'],
    title: '1x Zubehör'
  },
  // Add more if needed
]
